var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',{attrs:{"icon":"clock","title":"History"}},[_c('loading-spinner'),(!_vm.loadingStatus)?_c('History',{attrs:{"items":_vm.history,"show-actions":true}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }